"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ThemeContext: function() {
        return _ThemeContext.ThemeContext;
    },
    ThemeProvider: function() {
        return _ThemeContext.ThemeProvider;
    }
});
const _ThemeContext = require("./ThemeContext");
